import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Subscription, interval } from 'rxjs';
import { Meta } from '@angular/platform-browser';

export interface PublicWatchDto {
  id: number;
  lawyerName: string;
  judicialDistrict: string;
  alertType: string;
  status: string;
  start: string;
  end: string | null;
}

@Component({
  selector: 'app-public-watches',
  templateUrl: './public-watches.component.html',
  styleUrls: ['./public-watches.component.scss'],
})
export class PublicWatchesComponent implements OnInit, OnDestroy {
  watches: PublicWatchDto[] = [];
  errorMessage: string | null = null;
  private token: string;
  private pollingSubscription: Subscription;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private meta: Meta
  ) {}

  ngOnInit(): void {
    document.body.classList.add('public-view');
    this.meta.addTag({ name: 'robots', content: 'noindex' });

    this.token = this.route.snapshot.queryParams['token'];
    this.loadWatches();

    this.pollingSubscription = interval(5 * 60 * 1000).subscribe(() =>
      this.loadWatches()
    );
  }

  ngOnDestroy(): void {
    document.body.classList.remove('public-view');
    this.meta.removeTag('name="robots"');

    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }

  statusIcon(watch: PublicWatchDto): string {
    switch (watch.status) {
      case 'OK': return 'account';
      case 'CONFIRMED': return 'account-check';
      case 'SEARCHING_SUBSTITUTE': return 'account-search';
      case 'COMPLETED': return 'account-heart';
      case 'CANCELLED': return 'account-cancel';
      default: return 'account';
    }
  }

  statusColor(watch: PublicWatchDto): string {
    switch (watch.status) {
      case 'OK':
      case 'CONFIRMED':
      case 'COMPLETED': return 'success';
      case 'SEARCHING_SUBSTITUTE': return 'warning';
      case 'CANCELLED': return 'danger';
      default: return '';
    }
  }

  statusText(watch: PublicWatchDto): string {
    switch (watch.status) {
      case 'OK': return 'Activo';
      case 'CONFIRMED': return 'Confirmado';
      case 'SEARCHING_SUBSTITUTE': return 'Buscando substituto';
      case 'COMPLETED': return 'Completado';
      case 'CANCELLED': return 'Perdido';
      default: return watch.status;
    }
  }

  private loadWatches(): void {
    this.http
      .get<PublicWatchDto[]>('/api/public/watches', {
        params: { token: this.token },
      })
      .subscribe({
        next: (data) => {
          this.watches = data;
          this.errorMessage = null;
        },
        error: (err: HttpErrorResponse) => {
          if (err.status === 401) {
            this.errorMessage = 'Acceso no autorizado. Token inválido.';
          }
        },
      });
  }
}
